interface GtmSdkParams {
  playerID: string | null;
  eventTime: Date;
  screenName?: ScreenName;
}
type ScreenName = "mainPage" | "logIn" | "signUp";

// EventTrigger название кнопки (раздела) кликнутое в хедере. например :features, casino, series...
// используется для передачи в buttonName
type EventTrigger = { triggerId: string };

// EventTarget - раздел на который кликнул пользователь в выпадающием списке. используется для передачи в value
type EventTarget = {
  targetId: string;
};

export class GtmSdk {
  constructor(private readonly dataLayer: DataLayer) {}
  private formatDate(date: Date): string {
    return date.toISOString();
  }

  // клик на кнопку Log In на лендинге (либо в хэдере, либо в центре страницы)
  public loginHeader(params: GtmSdkParams): void {
    this.dataLayer.push({
      event: "event",
      eventFlow: "logIn",
      eventLocation: "landing",
      eventAction: "click",
      eventLabel: "logInHeader",
      eventTime: this.formatDate(params.eventTime),
      screenName: params.screenName,
      PlayerID: params.playerID,
    });
  }

  // клик на кнопку Create Account на лендинге (либо в хэдере, либо в центре страницы)
  public createAccountHeader(params: GtmSdkParams): void {
    this.dataLayer.push({
      event: "event",
      eventFlow: "registration",
      eventLocation: "landing",
      eventAction: "click",
      eventLabel: "createAccountHeader",
      eventTime: this.formatDate(params.eventTime),
      screenName: params.screenName,
      PlayerID: params.playerID,
    });
  }

  // Клик на одну из кнопок в хедере (не учитывая выбор языка, логин, регистрация). То есть то что находится в левой части хедера.
  public clickHeaderMain(params: GtmSdkParams & EventTrigger): void {
    this.dataLayer.push({
      event: "event",
      eventFlow: "all",
      eventAction: "click",
      eventLocation: "landing",
      eventLabel: "clickHeaderMain",
      eventTime: this.formatDate(params.eventTime),
      PlayerID: params.playerID,
      buttonName: params.triggerId,
    });
  }

  // После клика на одну из кнопок в хедера появляется либо выпадающий список либо редиректит на новый юрл. Это события должно тригерится при нажатии на один из разделов с выпадающим списком.
  public clickHeaderSub(
    params: GtmSdkParams & EventTrigger & EventTarget,
  ): void {
    this.dataLayer.push({
      event: "event",
      eventFlow: "all",
      eventAction: "click",
      eventLocation: "landing",
      eventLabel: "clickHeaderSub",
      eventTime: this.formatDate(params.eventTime),
      PlayerID: params.playerID,
      buttonName: params.triggerId,
      value: params.targetId,
    });
  }

  // клик на кнопку Log In на лендинге (либо в хэдере, либо в центре страницы)
  public logInMain(params: GtmSdkParams): void {
    this.dataLayer.push({
      event: "event",
      eventFlow: "logIn",
      eventLocation: "landing",
      eventAction: "click",
      eventLabel: "logInMain",
      screenName: params.screenName,
      PlayerID: params.playerID,
      eventTime: this.formatDate(params.eventTime),
    });
  }

  // клик на кнопку Create Account на лендинге (либо в хэдере, либо в центре страницы)
  public createAccountMain(params: GtmSdkParams): void {
    this.dataLayer.push({
      event: "event",
      eventFlow: "registration",
      eventTime: this.formatDate(params.eventTime),
      eventLocation: "landing",
      eventAction: "click",
      eventLabel: "createAccountMain",
      screenName: params.screenName,
      PlayerID: params.playerID,
    });
  }

  // клик на кнопку Play Now
  public playNow(params: GtmSdkParams): void {
    this.dataLayer.push({
      event: "event",
      eventFlow: "landing",
      eventLocation: "landing",
      eventAction: "click",
      eventLabel: "PlayNow",
      eventTime: this.formatDate(params.eventTime),
      screenName: params.screenName,
      PlayerID: params.playerID,
    });
  }
}
